export default {
      id: "i-pie-chart-usage",
      viewBox: "0 0 62 62",
      url: __webpack_public_path__ + "img/sprite.svg#i-pie-chart",
      toString: function () {
        return this.url;
      }
    }